export { default } from './CarrosEletricosBannerImg';
